import { render } from "./verify.vue?vue&type=template&id=77d71d62"
import script from "./verify.vue?vue&type=script&lang=js"
export * from "./verify.vue?vue&type=script&lang=js"

import "./verify.vue?vue&type=style&index=0&id=77d71d62&lang=less"
script.render = render

export default script